// extracted by mini-css-extract-plugin
export var attribution = "_9r-4";
export var authorName = "_9r-5";
export var quote = "_9r-3";
export var testimonial = "_9r-2";
export var trustedBy = "_9r-0";
export var trustedByLabel = "_9r-1";